import * as React from 'react';
import { App } from '../App';
import { ZoomInButton } from '@longline/aqua-ui/map/controls/ZoomInButton';
import { ZoomOutButton } from '@longline/aqua-ui/map/controls/ZoomOutButton';
import { CompassButton } from '@longline/aqua-ui/map/controls/CompassButton';
import { MapButtonGroup } from '@longline/aqua-ui/map/controls/base/MapButtonGroup';
import { ScaleControl } from '@longline/aqua-ui/map/controls/ScaleControl';
import { Geocoder } from '@longline/aqua-ui/map/controls/Geocoder';
import { FullscreenButton } from '@longline/aqua-ui/map/controls/FullscreenButton';
//import { useConfig } from '../services/config/IConfig';
import { AddCircularStructureButton } from './AddCircularStructureButton';
import { AddPolygonStructureButton } from './AddPolygonStructureButton';
import { ExportImageButton } from './ExportImageButton';
import { ToggleStructuresButton } from './ToggleStructuresButton';
import { EyedropperButton } from './EyedropperButton';

const MapControls = () => {
  //const config = useConfig();

  return (
    <>
      <MapButtonGroup x={-16} y={-48}>
        <CompassButton/>
        <ZoomInButton/>
        <ZoomOutButton/>
      </MapButtonGroup>
      <FullscreenButton x={-16} y={-152}/>
      <MapButtonGroup x={-16} y={16}>
        <AddCircularStructureButton x={-16} y={-159}/>
        <AddPolygonStructureButton x={-16} y={-198}/>
      </MapButtonGroup>
      <ToggleStructuresButton x={-16} y={90}/>
      <EyedropperButton x={-16} y={130}/>
      <ExportImageButton x={-16} y={-190}/>
      <ScaleControl x={-16} y={-16}/>
      <Geocoder searchIcon x={16} y={16} access_token={App.config.mapboxKey}/>
    </>
  );
}

export { MapControls }

